<script setup lang="ts">
import BrandLogo from './BrandLogo.vue';
</script>

<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-col">
          <a href="/" class="logo-link footer-logo" aria-label="ТКапитал — главная">
            <BrandLogo :size="34" show-text />
          </a>
          <p>
            Лизинг легковых автомобилей, коммерческого транспорта и спецтехники
            для юридических и физических лиц в Беларуси.
          </p>
        </div>

        <div class="footer-col">
          <h4>Разделы</h4>
          <ul>
            <li><a href="/">Главная</a></li>
            <li><a href="/requirements.html">Документы и требования</a></li>
            <li><a href="/about.html">О компании</a></li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>Контакты</h4>
          <ul>
            <li><a href="tel:+375339933338">+375 33 993-33-38</a></li>
            <li><a href="mailto:leasing@tcapital.by">leasing@tcapital.by</a></li>
            <li>г. Минск, ул. Победителей, 133-795</li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>Режим работы</h4>
          <ul>
            <li>Пн–Чт: 08:30–17:00</li>
            <li>Пт: 08:30–16:30</li>
            <li>Сб–Вс: выходной</li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-bottom-meta">
          <a href="/docs/tc_cookies.pdf" target="_blank" rel="noopener">Политика обработки cookie</a>
          <span>Ставки и условия — предварительные и не являются публичной офертой.</span>
        </div>
        <div class="footer-copyright">© 2026 ООО Лизинговая компания «Т-Капитал». Все права защищены.</div>
      </div>
    </div>
  </footer>
</template>
